import { action, makeObservable, observable } from "mobx";

class BreadcrumbStore {
  items = [];
  currentPath = "";

  constructor() {
    makeObservable(this, {
      items: observable,
      currentPath: observable,
      setItems: action,
      setCurrentPath: action,
      addItem: action,
      removeLastItem: action,
      clear: action,
    });
  }

  /**
   * Sets the breadcrumb items
   * @param {Array} items - Array of objects with { label, href? }
   */
  setItems = (items) => {
    this.items = items || [];
  };

  /**
   * Sets the current path
   * @param {string} path - Current path
   */
  setCurrentPath = (path) => {
    this.currentPath = path || "";
  };

  /**
   * Adds an item to the end of the breadcrumb
   * @param {Object} item - Object with { label, href? }
   */
  addItem = (item) => {
    if (item && item.label) {
      this.items.push(item);
    }
  };

  /**
   * Removes the last item from the breadcrumb
   */
  removeLastItem = () => {
    if (this.items.length > 0) {
      this.items.pop();
    }
  };

  /**
   * Clears all breadcrumb items
   */
  clear = () => {
    this.items = [];
    this.currentPath = "";
  };

  /**
   * Sets a complete breadcrumb with base and context
   * @param {Object} config - { base: { label, href }, context?: { label, href? } }
   */
  setBreadcrumb = (config) => {
    const { base, context } = config;
    const newItems = [];
    
    if (base) {
      newItems.push(base);
    }
    
    if (context) {
      newItems.push(context);
    }
    
    this.items = newItems;
  };

  /**
   * Getter to obtain items as immutable array
   */
  get breadcrumbItems() {
    return [...this.items];
  }

  /**
   * Getter to check if there are items
   */
  get hasItems() {
    return this.items.length > 0;
  }
}

export default BreadcrumbStore;
